/**
 * Poster + click-to-play for <pb-deferred-video>.
 * Uses capture-phase clicks so it works inside product <a> wrappers.
 */
(function () {
  if (window.__pbDeferredVideoInit) return;
  window.__pbDeferredVideoInit = true;

  var CSS_ID = 'pb-deferred-video-css';

  function injectStyles() {
    if (document.getElementById(CSS_ID)) return;
    var style = document.createElement('style');
    style.id = CSS_ID;
    style.textContent = [
      'pb-deferred-video.pb-deferred-video{position:absolute;inset:0;display:block;width:100%;height:100%;overflow:hidden;background:#1a1a1a;cursor:pointer}',
      '.pb-deferred-video__poster,.pb-deferred-video video{position:absolute;inset:0;width:100%;height:100%;object-fit:cover;object-position:center;display:block}',
      '.pb-deferred-video__poster--empty{background:#2a2a2a}',
      '.pb-deferred-video__play{position:absolute;top:50%;left:50%;z-index:3;display:flex;align-items:center;justify-content:center;width:64px;height:64px;margin:0;border-radius:50%;background:rgba(255,255,255,.92);color:#1a1a1a;box-shadow:0 4px 24px rgba(0,0,0,.2);transform:translate(-50%,-50%);transition:transform .2s ease,background .2s ease,box-shadow .2s ease;pointer-events:none}',
      '.pb-deferred-video__triangle{display:block;margin-left:3px}',
      '.pb-deferred-video:hover .pb-deferred-video__play{transform:translate(-50%,-50%) scale(1.06);background:#fff;box-shadow:0 6px 28px rgba(0,0,0,.28)}',
      '.pb-deferred-video.is-playing{cursor:default}',
      '.pb-deferred-video.is-playing .pb-deferred-video__poster,',
      '.pb-deferred-video.is-playing .pb-deferred-video__play{opacity:0;visibility:hidden;transition:opacity .25s ease}',
      '.pb-deferred-video.is-playing video{z-index:1}'
    ].join('');
    document.head.appendChild(style);
  }

  function playHost(host) {
    if (!host || host.classList.contains('is-playing')) return false;

    var src = host.getAttribute('data-src');
    if (!src) return false;

    if (src.indexOf('//') === 0) src = window.location.protocol + src;

    var video = document.createElement('video');
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');
    video.muted = true;
    video.defaultMuted = true;
    video.loop = true;
    video.playsInline = true;
    video.preload = 'auto';
    video.setAttribute('aria-label', host.getAttribute('aria-label') || 'Video');

    var source = document.createElement('source');
    source.src = src;
    source.type = host.getAttribute('data-type') || 'video/mp4';
    video.appendChild(source);
    host.appendChild(video);
    host.classList.add('is-playing');

    try {
      video.load();
    } catch (err) {}

    var playPromise = video.play();
    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(function () {
        video.controls = true;
        video.setAttribute('controls', '');
      });
    }

    return true;
  }

  function onClick(event) {
    var host = event.target.closest('pb-deferred-video');
    if (!host || host.classList.contains('is-playing')) return;

    // Beat parent <a> navigation
    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === 'function') {
      event.stopImmediatePropagation();
    }

    playHost(host);
  }

  function onKeydown(event) {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    var host = event.target.closest('pb-deferred-video');
    if (!host || host.classList.contains('is-playing')) return;
    event.preventDefault();
    playHost(host);
  }

  injectStyles();
  document.addEventListener('click', onClick, true);
  document.addEventListener('keydown', onKeydown, true);
})();
